import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {
		genres: [],
		data: {
			actors: [],
			writers: [],
			directors: [],
			producers: []
		},
		tabs: []
	},
	isLoaded: false,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR EVENT_LIVE STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH EVENT_LIVE ******************
			case types.FETCH_EVENT_LIVE_LOADING:
				return { ...INITIAL_STATE };

			case types.FETCH_EVENT_LIVE_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_EVENT_LIVE_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
